function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useCallback, useMemo, useState } from 'react';
export function useArray(initial) {
  var _useState = useState(initial),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var push = useCallback(function (a) {
    setValue(function (v) {
      return [].concat(_toConsumableArray(v), _toConsumableArray(Array.isArray(a) ? a : [a]));
    });
  }, []);
  var unshift = useCallback(function (a) {
    return setValue(function (v) {
      return [].concat(_toConsumableArray(Array.isArray(a) ? a : [a]), _toConsumableArray(v));
    });
  }, []);
  var pop = useCallback(function () {
    return setValue(function (v) {
      return v.slice(0, -1);
    });
  }, []);
  var shift = useCallback(function () {
    return setValue(function (v) {
      return v.slice(1);
    });
  }, []);
  var move = useCallback(function (from, to) {
    return setValue(function (it) {
      var copy = it.slice();
      copy.splice(to < 0 ? copy.length + to : to, 0, copy.splice(from, 1)[0]);
      return copy;
    });
  }, []);
  var clear = useCallback(function () {
    return setValue(function () {
      return [];
    });
  }, []);
  var removeById = useCallback(
  // @ts-ignore not every array that you will pass down will have object with id field.
  function (id) {
    return setValue(function (arr) {
      return arr.filter(function (v) {
        return v && v.id !== id;
      });
    });
  }, []);
  var removeIndex = useCallback(function (index) {
    return setValue(function (v) {
      var copy = v.slice();
      copy.splice(index, 1);
      return copy;
    });
  }, []);
  var modifyById = useCallback(function (id, newValue) {
    return (
      // @ts-ignore not every array that you will pass down will have object with id field.
      setValue(function (arr) {
        return arr.map(function (v) {
          return v.id === id ? Object.assign(Object.assign({}, v), newValue) : v;
        });
      })
    );
  }, []);
  var actions = useMemo(function () {
    return {
      setValue: setValue,
      add: push,
      unshift: unshift,
      push: push,
      move: move,
      clear: clear,
      removeById: removeById,
      removeIndex: removeIndex,
      pop: pop,
      shift: shift,
      modifyById: modifyById
    };
  }, [modifyById, push, unshift, move, clear, removeById, removeIndex, pop, shift]);
  return [value, actions];
}
export default useArray;